import { FileText } from 'lucide-react';
import { ComponentProps } from 'react';
import { Stack } from '../../../../design-system/stack/stack';
import { exhaustiveCheck } from '../../../../utils/exhaustive-check';
import { TabValue } from '../invoices-section-tabs/invoices-section-tabs';

type EmptyStateConnectedEmailProps = {
  variant: TabValue;
};

export const EmptyStateConnectedEmail = ({ variant }: EmptyStateConnectedEmailProps) => {
  const { title, lineOne, lineTwo } = getEmptyStateContent(variant);

  return (
    <Stack space={3} align="center" className="py-24">
      <div className="h-10 w-10 rounded-full bg-seapoint-gray-background-modal p-2.5">
        <FileText strokeWidth={1} className="h-full w-full object-cover" />
      </div>

      <Stack space={1} align="center">
        <h3 className="text-center text-sm font-medium leading-5 tracking-tight text-black">{title}</h3>

        <p className="text-center text-xs font-medium leading-5 tracking-tight text-seapoint-gray-text">{lineOne}</p>

        {lineTwo && (
          <p className="text-center text-xs font-medium leading-5 tracking-tight text-seapoint-gray-text">{lineTwo}</p>
        )}
      </Stack>
    </Stack>
  );
};

const getEmptyStateContent = (variant: ComponentProps<typeof EmptyStateConnectedEmail>['variant']) => {
  switch (variant) {
    case 'TO_PAY':
      return {
        title: 'Waiting for new invoices',
        lineOne: "We'll pull in any new invoices from your inbox.",
        lineTwo: "They'll show up here when they're ready for your approval and payment.",
      };
    case 'REVIEW_MATCHES':
      return {
        title: 'No review matches (yet)',
        lineOne: `Once you start reviewing matches, we'll automatically match them to transactions and list them here for easy tracking.`,
        lineTwo: undefined,
      };
    case 'COMPLETED':
      return {
        title: 'No completed invoices (yet)',
        lineOne: `Once you've paid invoices using Seapoint or approved matched invoices, we'll list them here for easy tracking.`,
        lineTwo: undefined,
      };
    default:
      return exhaustiveCheck(variant);
  }
};
